module.exports = __webpack_public_path__ + "static/img/t9.fe0cb06.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/taijia/t9.png
// module id = JkZc
// module chunks = 1